/**
 * Theme for Kronos public embeds (WP shortcodes).
 * Read once from the iframe URL query (`?theme=dark|light`).
 *
 * @returns {'dark'|'light'}
 */
export function getEmbedThemeFromUrl() {
    try {
        const theme = new URLSearchParams(window.location.search).get('theme');
        return theme === 'dark' ? 'dark' : 'light';
    } catch (_e) {
        return 'light';
    }
}

export default getEmbedThemeFromUrl;
